import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import Product from '@/views/Product'
import Opportunity from '@/views/Opportunity'
import Solution from '@/views/Solution'
import Business from '@/views/Business'
import Project from '@/views/Project'
import Technique from '@/views/Technique'
import About from '@/views/About'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      alias: '/index',
      name: 'index',
      component: Index
    }, {
      path: '/product',
      name: 'product',
      component: Product
    }, {
      path: '/opportunity',
      name: 'opportunity',
      component: Opportunity
    }, {
      path: '/solution',
      name: 'solution',
      component: Solution
    }, {
      path: '/business',
      name: 'business',
      component: Business
    }, {
      path: '/project',
      name: 'project',
      component: Project
    }, {
      path: '/Technique',
      name: 'technique',
      component: Technique
    }, {
      path: '/about',
      name: 'about',
      component: About
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js